import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "./config";
import { useNavigate } from "react-router-dom";
import "./css/OffTheShelf.css";

// Off-the-Shelf (OTS): curated, turnkey end-to-end bioinformatics pipelines,
// grouped into modality categories (e.g. "GENE EDITING"). Backend-driven: the
// catalog is managed by super-admins in the cloud-admin-portal. Only released +
// validated pipelines appear here. A category with no released pipelines shows
// a "Coming Soon" state.
const OffTheShelf = () => {
  const [categories, setCategories] = useState([]);
  const [pipelinesByCategory, setPipelinesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catsRes, pipesRes] = await Promise.all([
          axios.get(`${API_BASE}/ots-categories`),
          axios.get(`${API_BASE}/ots-pipelines`),
        ]);

        setCategories(catsRes.data || []);

        const grouped = {};
        (pipesRes.data || []).forEach((p) => {
          if (!grouped[p.category_id]) grouped[p.category_id] = [];
          grouped[p.category_id].push(p);
        });
        setPipelinesByCategory(grouped);
      } catch (err) {
        console.error("Error fetching Off-the-Shelf catalog:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="ots-page-container">
      <header className="ots-header">
        <h2>Off-the-Shelf Pipelines</h2>
        <h4>
          Turnkey, end-to-end solutions for contemporary bioinformatics
          applications &mdash; pick a pipeline and run it on your own data.
        </h4>
      </header>

      {loading ? (
        <p className="ots-loading">Loading catalog&hellip;</p>
      ) : categories.length === 0 ? (
        <div className="ots-empty">
          <div className="ots-empty-icon">🧬</div>
          <div className="ots-empty-title">No pipelines available yet</div>
          <div className="ots-empty-sub">
            Curated off-the-shelf pipelines are on the way. Check back soon.
          </div>
        </div>
      ) : (
        <div className="ots-grid">
          {categories.map((cat) => {
            const pipelines = pipelinesByCategory[cat.id] || [];
            return (
              <div key={cat.id} className="ots-card">
                <div className="ots-card-head">
                  {cat.icon && <span className="ots-card-icon">{cat.icon}</span>}
                  <div className="ots-card-title">{cat.name}</div>
                </div>

                {cat.description && (
                  <div className="ots-card-desc">{cat.description}</div>
                )}

                <div className="ots-pipeline-buttons">
                  {pipelines.length > 0 ? (
                    pipelines.map((p) => (
                      <button
                        key={p.id}
                        className="ots-pipeline-btn"
                        title={p.description || p.display_name}
                        onClick={() => navigate(`/off-the-shelf/pipeline/${p.id}`)}
                      >
                        {p.display_name}
                      </button>
                    ))
                  ) : (
                    <div className="ots-coming-soon">Coming Soon</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OffTheShelf;
